"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");

var AbstractRelease_1 = require("../AbstractRelease");

var SelloutImpactRecord_1 = require("./SelloutImpactRecord");

var SelloutRelease_1 = require("./SelloutRelease");
/**
 * Contains all data related to (re)open of sellout release necessary for releases page. This is
 * used by CommonReleaseOverview.
 *
 * @author Jan Prokop
 */


var SelloutReleasePreviousOpenOverview =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleasePreviousOpenOverview, _DomainObject_1$Domai);

  function SelloutReleasePreviousOpenOverview(priceValidityStartDate, endDate, discountPercent, minPriceChangeInPercent, maxPriceChangeInPercent, minMarginChangeInPercent) {
    var _this;

    _classCallCheck(this, SelloutReleasePreviousOpenOverview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleasePreviousOpenOverview).call(this));
    _this.priceValidityStartDate = priceValidityStartDate;
    _this.endDate = endDate;
    _this.discountPercent = discountPercent;
    _this.minPriceChangeInPercent = minPriceChangeInPercent;
    _this.maxPriceChangeInPercent = maxPriceChangeInPercent;
    _this.minMarginChangeInPercent = minMarginChangeInPercent;
    return _this;
  }

  _createClass(SelloutReleasePreviousOpenOverview, [{
    key: "updateByImpact",
    value: function updateByImpact(impact) {
      return this.copyMulti({
        discountPercent: impact.discountPercent || null
      });
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutReleasePreviousOpenOverview(mat.priceValidityStartDate, mat.endDate, mat.discountPercent, mat.minPriceChangeInPercent, mat.maxPriceChangeInPercent, mat.minMarginChangeInPercent);
    }
  }]);

  return SelloutReleasePreviousOpenOverview;
}(DomainObject_1.DomainObject);

exports.SelloutReleasePreviousOpenOverview = SelloutReleasePreviousOpenOverview;
/**
 * This schema is for data type validation only. Cannot be used in AG grid to describe columns.
 */

SelloutReleasePreviousOpenOverview.schema = {
  priceValidityStartDate: AbstractRelease_1.AbstractRelease.schemaBase.priceValidityStartDate.base,
  endDate: SelloutRelease_1.SelloutRelease.schema.endDate,
  discountPercent: SelloutImpactRecord_1.SelloutImpactRecord.schema.discountPercent,
  minPriceChangeInPercent: SelloutRelease_1.SelloutRelease.schema.minPriceChangeInPercent,
  maxPriceChangeInPercent: SelloutRelease_1.SelloutRelease.schema.maxPriceChangeInPercent,
  minMarginChangeInPercent: SelloutRelease_1.SelloutRelease.schema.minMarginChangeInPercent
};